import { StripeOrdersListScreen } from "./StripeOrdersListScreen.tsx";

export const AdminStripeAllOrdersScreenPath = "/admin/stripe/all-orders";

export function AdminStripeAllOrdersScreen() {
  return <StripeOrdersListScreen />;
}
